export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15227.5acfee06.jpg";